var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscendingCopy73(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "425C4DDD-6CA9-4BF8-9E9E-1465EB293D1D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-202.000000, -884.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-73",
    transform: "translate(202.000000, 884.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.991,5 C9.023,5 5,9.032 5,14 C5,18.968 9.023,23 13.991,23 C18.968,23 23,18.968 23,14 C23,9.032 18.968,5 13.991,5 Z M20.228,10.4 L17.573,10.4 C17.285,9.275 16.871,8.195 16.331,7.196 C17.987,7.763 19.364,8.915 20.228,10.4 Z M14,6.836 C14.747,7.916 15.332,9.113 15.719,10.4 L12.281,10.4 C12.668,9.113 13.253,7.916 14,6.836 Z M7.034,15.8 C6.89,15.224 6.8,14.621 6.8,14 C6.8,13.379 6.89,12.776 7.034,12.2 L10.076,12.2 C10.004,12.794 9.95,13.388 9.95,14 C9.95,14.612 10.004,15.206 10.076,15.8 L7.034,15.8 Z M7.772,17.6 L10.427,17.6 C10.715,18.725 11.129,19.805 11.669,20.804 C10.013,20.237 8.636,19.094 7.772,17.6 L7.772,17.6 Z M10.427,10.4 L7.772,10.4 C8.636,8.906 10.013,7.763 11.669,7.196 C11.129,8.195 10.715,9.275 10.427,10.4 L10.427,10.4 Z M14,21.164 C13.253,20.084 12.668,18.887 12.281,17.6 L15.719,17.6 C15.332,18.887 14.747,20.084 14,21.164 Z M16.106,15.8 L11.894,15.8 C11.813,15.206 11.75,14.612 11.75,14 C11.75,13.388 11.813,12.785 11.894,12.2 L16.106,12.2 C16.187,12.785 16.25,13.388 16.25,14 C16.25,14.612 16.187,15.206 16.106,15.8 Z M16.331,20.804 C16.871,19.805 17.285,18.725 17.573,17.6 L20.228,17.6 C19.364,19.085 17.987,20.237 16.331,20.804 L16.331,20.804 Z M17.924,15.8 C17.996,15.206 18.05,14.612 18.05,14 C18.05,13.388 17.996,12.794 17.924,12.2 L20.966,12.2 C21.11,12.776 21.2,13.379 21.2,14 C21.2,14.621 21.11,15.224 20.966,15.8 L17.924,15.8 Z",
    id: "Shape",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingCopy73);
export default __webpack_public_path__ + "static/media/ascending Copy 73.20b4ed95369647275cd702fd88699f71.svg";
export { ForwardRef as ReactComponent };